import {DuplicationWrapper} from '../../../allkey/framework/parameters/DuplicationWrapper';
import {Vision} from '../message/Vision';
import {VisionDuplicationScenario} from './VisionDuplicationScenario';

export class VisionDuplicationWrapper extends DuplicationWrapper<Vision, VisionDuplicationScenario>  {}

